import { axios } from '~/clients';
import { GET_DELIVERY_PICKUP } from '~/constants/endpoints';
import { InventoryTypeId, InventoryTypeKey } from '~/constants/inventoryType';
import type { Vehicle } from '~/contracts/srp';
import { DeliveryPickupResponse } from '~/services/common/contracts';
import { BrowserCookies } from '~/utilities';

type VehicleForRequest = {
  vehicleId: number;
  vehicleInventoryType: InventoryTypeId | InventoryTypeKey;
  vehicleLocationId: number;
  vehicleSaleStatus: string;
};

export function formatVehicleForRequest({
  locationId,
  vehicleId,
  vehicleInventoryType,
  isPurchasePending
}: Vehicle): VehicleForRequest {
  const vehicleSaleStatus = isPurchasePending ? '' : 'Available';

  return {
    vehicleId,
    vehicleInventoryType,
    vehicleLocationId: locationId,
    vehicleSaleStatus
  };
}

type OwnArgs = {
  clientId: string;
  correlationId: string;
  userId: string;
  vehicles: VehicleForRequest[];
  zip: string;
};

export default function fetchVehiclesDeliveryPickup(
  { clientId, correlationId, userId, vehicles, zip }: OwnArgs,
  controller: AbortController
) {
  return axios.post<DeliveryPickupResponse>(
    GET_DELIVERY_PICKUP,
    {
      userId,
      vehicles,
      zipCode: zip
    },
    {
      headers: {
        browsercookieid: BrowserCookies.get('BrowserCookieId') ?? '',
        clientId,
        correlationId
      },
      signal: controller.signal
    }
  );
}
